import './Routine.css';
import React, { useState } from "react";
import addDailyPoints from '../../../../assets/functions/addDailyPoints';

function Routine(props) {
    const [completedSteps, setCompletedSteps] = useState([false, false, false, false, false, false, false, false])
    const [activeStep, setActiveStep] = useState(0)
    let routineSteps = [...props.routine]
    function populateRoutineSteps(routineArray) {
        // stop condition
        if (routineArray.length === 8) {
            return routineArray
        } else {
            let newRoutineArray = [...routineArray]
            newRoutineArray.push("[add a task to reach 8!]")
            return populateRoutineSteps(newRoutineArray)
        }
    }
    let populatedRoutineSteps = populateRoutineSteps(routineSteps)

    function editCompletedStep() {
        let newCompletedSteps = [...completedSteps]
        newCompletedSteps[activeStep] = true
        setCompletedSteps(newCompletedSteps)
    }

    return (
        <div className="morningRoutine">
            <div className="overallCircle">
                <div className="outerRoutineCircles">
                {completedSteps.map((step, index) => (
                    <div key={index} onClick={() => setActiveStep(index)} className={"circle circle" + index}>
                        <div className={"innerRoutineCircle " + (step ? "completedInnerRoutineCircle" : "")}> </div>
                    </div>
                ))}
                </div>
                <div className="innerRoutineCircles"> 
                    <div className="innerRingRoutineCircle">
                        {completedSteps.every(element => element === true) && 
                        <div>
                            <p className="routineInfoText"> routine completed! </p>
                            <p className="routineCompletedButton" onClick={() => addDailyPoints("glow")}> claim glow points</p>
                        </div>
                        }
                        {!completedSteps.every(element => element === true) && 
                        <div>
                        <p className="routineInfoText"> {populatedRoutineSteps[activeStep]} </p>
                        <p className="routineCompletedButton" onClick={() => editCompletedStep()}> mark completed</p>
                        </div>
}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Routine;